/* eslint-disable @typescript-eslint/naming-convention, react/require-default-props */
import React, { useRef, useState } from 'react';
import { Button } from '../../../../../../ui/atoms/Button';
import './SuggestedActionsBarStyles.scss';
const BASE_CLASS = 'ai-suggested-actions-bar';
export function SuggestedActionsBar({ actions, onAction }) {
    const [isDisabled, setIsDisabled] = useState(false);
    const actionTriggeredRef = useRef(false);
    if (actions.length === 0)
        return null;
    const handleAction = (action) => {
        if (actionTriggeredRef.current)
            return;
        actionTriggeredRef.current = true;
        setIsDisabled(true);
        onAction(action);
    };
    return (React.createElement("div", { className: BASE_CLASS }, actions.map((action) => (React.createElement(Button, { key: action.label, variant: "secondary", className: `${BASE_CLASS}__chip`, disabled: isDisabled, onClick: () => handleAction(action) },
        action.icon && React.createElement("i", { className: action.icon }),
        action.label)))));
}
